import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import ArrowRight from '@assets/svgs/gym/arrow_right.svg'
import SmileIcon from '@assets/svgs/gym/smile.svg'
import TickIcon from '@assets/svgs/gym/tick.svg'
import PairPart from '@assets/images/gym/pair-part.png'
import Volume from '@assets/svgs/gym/volume.svg'
import {
  upDateIsShowIntroduce,
  upDateTotalPracticeRecording,
  updateRerender,
} from '@redux/gym/gymSlice'
import {useDispatch, useSelector} from 'react-redux'
import gymRequest from '@apis/gym'
import MicCard from '../components/MicCard'
import ModalClosePage from '../components/ModalClosePage'
import rightAudio from '@assets/audios/right.mp3'
import wrongAudio from '@assets/audios/wrong.mp3'
import './index.css'
import TopTitle from '../components/TopTitle'
import LessonProgress from '../components/LessonProgress'
import AOS from 'aos'
import 'aos/dist/aos.css'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import {isParamsValid} from '@utils'

const GymPracticePage = () => {
  const stateGym = useSelector((state: any) => state.gym)
  const practiceDataSpeech = stateGym?.practiceDataSpeech
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {lesson_id, lesson_name, type, entry_point, task_id} =
    useLocation().state || {}
  const [practices, setPractices] = useState<any>()
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const [currentPractice, setCurrentPractice] = useState<any>(
    practices?.questions[currentIndex],
  )
  const [practiceSelected, setPracticeSelected] = useState<any>('')
  const [isFinish, setIsFinish] = useState<Boolean>(false)

  useEffect(() => {
    if (!isParamsValid([lesson_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!lesson_id) return
    getPairList()
  }, [])

  useEffect(() => {
    AOS.init()
  }, [])

  useEffect(() => {
    if (!stateGym.isRender) {
      dispatch(updateRerender(true))
    }
  }, [stateGym.isRender])

  useEffect(() => {
    if (practices?.questions[0]) {
    }
    setCurrentPractice(practices?.questions[currentIndex])
  }, [practices, currentIndex])

  useEffect(() => {
    if (
      !stateGym.isShowIntroduce &&
      currentPractice?.type_learn === 'KIEM_TRA'
    ) {
      setTimeout(() => {
        handleReplay(currentPractice?.audio_path)
      }, 600)
    }
  }, [currentPractice, stateGym.isShowIntroduce])

  const getPairList = async () => {
    try {
      const pronounceList = await gymRequest.getGymLessonResult({
        lessonId: lesson_id,
        type: type,
      })
      setPractices(pronounceList.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChooseAnswer = (value: any) => {
    if (!practiceSelected) {
      if (value === currentPractice?.data?.correct_answer) {
        new Audio(rightAudio).play()
      } else {
        new Audio(wrongAudio).play()
      }
      setPracticeSelected(value)
      setTimeout(() => {
        handleSendDetailsResults(
          value === currentPractice?.data?.correct_answer ? 100 : 0,
          currentPractice?.ipa_lesson_detail_id,
          lesson_id,
          practices?.turn_play,
          type,
          practices?.questions.length == currentIndex + 1,
        )
        setPracticeSelected('')
        handleContinue()
      }, 2000)
    }
  }

  const handleContinue = () => {
    dispatch(upDateTotalPracticeRecording(0))
    setIsFinish(false)
    if (practices?.questions.length > currentIndex + 1) {
      setCurrentIndex(pre => pre + 1)
    } else {
      navigate('/gym/result', {
        state: {
          entry_point,
          task_id,
        },
      })
    }
  }

  const handleSendDetailsResults = async (
    score: any,
    ipa_lesson_detail_id: any,
    ipa_lesson_id: any,
    turn_play: any,
    type_learn: any,
    is_last_question: any,
  ) => {
    try {
      gymRequest.sendDetailsResults({
        score,
        ipa_lesson_detail_id,
        ipa_lesson_id,
        turn_play,
        type_learn,
        is_last_question,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleReplay = (audioFile: any) => {
    const audio = new Audio(audioFile)
    audio.play()
  }

  return (
    <Flex
      h={'100vh'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      overflow={'hidden'}>
      <TopTitle lessonName={lesson_name} type={type} />
      {stateGym.isShowIntroduce && (
        <Flex
          data-aos="fade-left"
          flexGrow={1}
          justifyContent={'center'}
          alignItems={'center'}
          gap={'50px'}
          flexDirection={{base: 'column', md: 'row'}}>
          <Image src={PairPart} w={'180px'} h={'180px'} borderRadius={'50%'} />
          <Box textAlign={{base: 'center', md: 'left'}}>
            <Text fontSize={'24px'} fontWeight={600}>
              Luyện tập phát âm
            </Text>
            <Text my={'16px'} fontWeight={600} maxW={'290px'} fontSize={'16px'}>
              Tăng cường luyện tập để cải thiện khả năng phát âm bạn nhé!
            </Text>
            <Button
              color={'white'}
              bg={'#1890FF'}
              borderRadius={'12px'}
              display={'flex'}
              gap={'16px'}
              alignItems={'center'}
              mx={{base: 'auto', md: 'unset'}}
              onClick={() => dispatch(upDateIsShowIntroduce(false))}>
              Tiếp tục
              <Image src={ArrowRight} />
            </Button>
          </Box>
        </Flex>
      )}
      {!stateGym.isShowIntroduce && (
        <Flex flexDirection={'column'} flexGrow={1}>
          <LessonProgress
            currentIndex={currentIndex}
            data={practices?.questions}
          />
          {currentPractice?.type_learn === 'KIEM_TRA' && (
            <Flex
              data-aos="fade-left"
              flexGrow={1}
              flexDirection={'column'}
              // maxW={'1000px'}
              w={'100%'}
              alignItems={'center'}
              justifyContent={'center'}
              mx={'auto'}
              gap={{md: '32px'}}>
              <Text
                fontSize={{base: '18px', md: '24px'}}
                fontWeight={700}
                color={'#8C8C8C'}
                align={'center'}>
                Nghe và chọn đáp án đúng
              </Text>
              <Flex flexDirection={'column'} alignItems={'center'} w={'100%'}>
                <Flex
                  w={'80px'}
                  h={'80px'}
                  bg={'#D1E9FF'}
                  borderRadius={'50%'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  my={'24px'}
                  cursor={'pointer'}
                  _hover={{bg: '#a2d2ff'}}
                  onClick={() => {
                    handleReplay(currentPractice?.audio_path)
                  }}>
                  <Image src={Volume} w={'40px'} h={'40px'} />
                </Flex>
                <Text fontSize={'30px'} fontWeight={700} align={'center'}>
                  {currentPractice?.data?.content}
                </Text>
                <Text
                  fontSize={'16px'}
                  fontWeight={600}
                  color={'#8C8C8C'}
                  align={'center'}>
                  {currentPractice?.data?.meaning_vn}
                </Text>
                <Flex
                  gap={{base: '16px', md: '33px'}}
                  mt={'50px'}
                  mb={'64px'}
                  w={'100%'}
                  px={{base: '16px', md: 0}}
                  justifyContent={'center'}>
                  {currentPractice?.data?.answer_list?.map(
                    (item: any, index: any) => {
                      return (
                        <Flex
                          key={index}
                          className={
                            practiceSelected &&
                            practiceSelected === item &&
                            currentPractice?.data?.correct_answer !== item
                              ? 'animate'
                              : ''
                          }
                          w={'350px'}
                          borderWidth={'2px'}
                          borderColor={
                            practiceSelected
                              ? currentPractice?.data?.correct_answer === item
                                ? '#379652'
                                : practiceSelected === item
                                  ? '#E55856'
                                  : '#BFBFBF'
                              : '#BFBFBF'
                          }
                          borderRadius={'16px'}
                          p={'10px'}
                          cursor={'pointer'}
                          textColor={
                            practiceSelected
                              ? currentPractice?.data?.correct_answer === item
                                ? '#379652'
                                : practiceSelected === item
                                  ? '#E55856'
                                  : ''
                              : 'black'
                          }
                          _hover={{
                            boxShadow: '0px 0px 8px 2px #ccc',
                          }}
                          onClick={() => handleChooseAnswer(item)}>
                          <Text
                            fontSize={'20px'}
                            fontWeight={600}
                            align={'center'}
                            w={'100%'}>
                            {item}
                          </Text>
                        </Flex>
                      )
                    },
                  )}
                </Flex>
              </Flex>
            </Flex>
          )}
          {currentPractice?.type_learn === 'LUYEN_TAP' && (
            <Flex
              data-aos="fade-left"
              flexDirection={'column'}
              flexGrow={1}
              justifyContent={'center'}>
              <Text
                fontSize={'24px'}
                fontWeight={700}
                align={'center'}
                color={'#8C8C8C'}>
                Phát âm từ sau
              </Text>
              <Box
                w={{base: '300px', md: '370px'}}
                mx={'auto'}
                mt={{base: 0, md: '32px'}}>
                <MicCard
                  data={currentPractice}
                  setIsFinish={setIsFinish}
                  setIsPlayingVideo={null}
                />
              </Box>
            </Flex>
          )}
        </Flex>
      )}
      {!stateGym.isShowIntroduce && (
        <Box borderTop={'2px solid #e5e5e5'}>
          <Flex
            maxW={'1000px'}
            py={{base: '16px', lg: '32px'}}
            px={'16px'}
            mx={'auto'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={'16px'}>
            {isFinish ? (
              <Text
                color={'#003D75'}
                fontSize={{base: '16px', md: '20px'}}
                fontWeight={700}
                display={'flex'}
                alignItems={'center'}>
                <Image
                  src={TickIcon}
                  w={stateGym.isGoodRecording ? '50px' : 0}
                />
                <Image
                  src={SmileIcon}
                  w={!stateGym.isGoodRecording ? '50px' : 0}
                />
                <Text pl={'16px'}>
                  {stateGym.isGoodRecording ? 'Xuất sắc!' : 'Cố gắng hơn nhé!'}
                </Text>
              </Text>
            ) : (
              <Box></Box>
            )}
            <Button
              isDisabled={!isFinish}
              color={'white'}
              borderRadius={'12px'}
              bg={'#003D75'}
              _hover={{
                bg: '#0066c4',
              }}
              _disabled={{
                bg: '#c9c9c9',
                cursor: 'unset',
              }}
              onClick={() => {
                dispatch(updateRerender(false))
                handleContinue()
                handleSendDetailsResults(
                  Math.round(Number(practiceDataSpeech?.total_score) * 100),
                  currentPractice?.ipa_lesson_detail_id,
                  lesson_id,
                  practices?.turn_play,
                  type,
                  practices?.questions.length == currentIndex + 1,
                )
              }}>
              Tiếp tục
            </Button>
          </Flex>
        </Box>
      )}
      <FormReportError
        feature={FEATURE_REPORT_ERROR.IPA_COURSE}
        screen={SCREEN_REPORT_ERROR.LUYEN_TAP}
      />
      <ModalClosePage />
    </Flex>
  )
}

export default GymPracticePage
